import { useSyncExternalStore } from 'react';
import { useUnsavedChangesBlocker } from '@/shared/hooks/useUnsavedChangesBlocker';
import {
    discardUnsavedChanges,
    hasUnsavedChanges,
    subscribeUnsavedChanges,
} from '@/shared/model/unsavedChanges';

/** Защищает все открытые формы одним блокировщиком маршрутов */
export const UnsavedChangesGuard = () => {
    useSyncExternalStore(subscribeUnsavedChanges, hasUnsavedChanges, hasUnsavedChanges);

    useUnsavedChangesBlocker({
        when: hasUnsavedChanges,
        onDiscard: discardUnsavedChanges
    });

    return null;
};
